import {defer} from 'rxjs';

export function makeCache(getValue) {
  let cache = null;
  const observable = defer(() => {
    if (!cache) {
      cache = getValue();
    }
    return cache;
  });
  observable.clearCache = () => cache = null;
  return observable;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/utils/makeCache.js